import { useNavigate } from 'react-router-dom';

/**
 * Back that never dead-ends: pops in-app history when there is some,
 * otherwise replaces the current page with `fallback` (e.g. when the page
 * was opened directly from a link). Uses React Router's own history index —
 * `history.length` also counts external/redirect entries and lies.
 */
export function canGoBackInApp() {
  return typeof window !== 'undefined' && (window.history.state?.idx ?? 0) > 0;
}

export function useSafeBack(fallback = '/home') {
  const navigate = useNavigate();
  return () => {
    if (canGoBackInApp()) navigate(-1);
    else navigate(fallback, { replace: true });
  };
}
